import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HouseIcon from '@mui/icons-material/House';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import SnowshoeingIcon from '@mui/icons-material/Snowshoeing';
import SearchIcon from '@mui/icons-material/Search';
import MuseumIcon from '@mui/icons-material/Museum';

const MobileBottomNav = () => {
   const [value, setValue] = useState(0);

   return (
      <AppBar position="fixed" color="primary" sx={{ display: { xs: 'flex', md: 'none' }, top: 'auto', bottom: 0 }}>
         <BottomNavigation
            showLabels
            value={value}
            onChange={(event, newValue) => {
               setValue(newValue);
            }}
         >
            <BottomNavigationAction
               label="Journey"
               icon={<SnowshoeingIcon />}
               component={Link}
               to="/"
            />
            <BottomNavigationAction
               label="Records"
               icon={<HouseIcon />}
               component={Link}
               to="/my-records"
            />
            <BottomNavigationAction
               label="Wishes"
               icon={<FavoriteBorderIcon />}
               component={Link}
               to="/final-wishes"
            />
            <BottomNavigationAction
               label="Mausoleum"
               icon={<MuseumIcon />}
               component={Link}
               to="/mausoleum"
            />
            <BottomNavigationAction
               label="Search"
               icon={<SearchIcon />}
               component={Link}
               to="/mausolea-search"
            />
         </BottomNavigation>
      </AppBar>
   );
};

export default MobileBottomNav;
